
/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ClientLegalEntityVerificationRequestStatusResource,
  VerificationRequestCreationResource,
} from '../models';
import {
    ClientLegalEntityVerificationRequestStatusResourceFromJSON,
    ClientLegalEntityVerificationRequestStatusResourceToJSON,
    VerificationRequestCreationResourceFromJSON,
    VerificationRequestCreationResourceToJSON,
} from '../models';

export interface GetClientLegalEntityVerificationRequestStatusRequest {
    legalEntityId: string;
}

export interface RequestClientLegalEntityVerificationRequest {
    legalEntityId: string;
    verificationRequestCreationResource: VerificationRequestCreationResource;
}

/**
 * 
 */
export class ClientLegalEntityVerificationRequestApi extends runtime.BaseAPI {

    /**
     * Get manual verification request status for a legal entity
          */
    async getClientLegalEntityVerificationRequestStatusRaw(requestParameters: GetClientLegalEntityVerificationRequestStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ClientLegalEntityVerificationRequestStatusResource>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling getClientLegalEntityVerificationRequestStatus().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<ClientLegalEntityVerificationRequestStatusResource>({
            path: `/compliance/api/legal-entities/{legalEntityId}/verification-request-status`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=ClientLegalEntityVerificationRequestStatusResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get manual verification request status for a legal entity
          */
    async getClientLegalEntityVerificationRequestStatus(requestParameters: GetClientLegalEntityVerificationRequestStatusRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ClientLegalEntityVerificationRequestStatusResource> {
        const response = await this.getClientLegalEntityVerificationRequestStatusRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Request manual verification for a legal entity
          */
    async requestClientLegalEntityVerificationRaw(requestParameters: RequestClientLegalEntityVerificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['legalEntityId'] == null) {
            throw new runtime.RequiredError(
                'legalEntityId',
                'Required parameter "legalEntityId" was null or undefined when calling requestClientLegalEntityVerification().'
            );
        }

        if (requestParameters['verificationRequestCreationResource'] == null) {
            throw new runtime.RequiredError(
                'verificationRequestCreationResource',
                'Required parameter "verificationRequestCreationResource" was null or undefined when calling requestClientLegalEntityVerification().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/compliance/api/legal-entities/{legalEntityId}/verification-requests`.replace(`{${"legalEntityId"}}`, encodeURIComponent(String(requestParameters['legalEntityId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: VerificationRequestCreationResourceToJSON(requestParameters['verificationRequestCreationResource']),
        }, initOverrides);

        return response;
    }

    /**
     * Request manual verification for a legal entity
          */
    async requestClientLegalEntityVerification(requestParameters: RequestClientLegalEntityVerificationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.requestClientLegalEntityVerificationRaw(requestParameters, initOverrides);
    }

}
